import React from 'react';
import { CurrentPlans, BillingAccounts, BillingHistory } from '../components';

export const BillingPage = () => {
  return (
    <div className="flex flex-col gap-8">
      <CurrentPlans />
      <BillingAccounts />
      <BillingHistory />
    </div>
  );
};